import React from 'react';
import { StickyBar } from '../components/sales/StickyBar';
import { Hero } from '../components/sales/Hero';
import { Empathy } from '../components/sales/Empathy';
import { Problem } from '../components/sales/Problem';
import { Solution } from '../components/sales/Solution';
import { Different } from '../components/sales/Different';
import { Testimonials } from '../components/sales/Testimonials';
import { Offer } from '../components/sales/Offer';
import { FAQ } from '../components/sales/FAQ';
import { FinalCTA } from '../components/sales/FinalCTA';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <div className="min-h-screen" data-id="element-408">
      <StickyBar data-id="element-409" />
      <main className="pt-10" data-id="element-410">
        <Hero data-id="element-411" />
        <Empathy data-id="element-412" />
        <Problem data-id="element-413" />
        <Solution data-id="element-414" />
        <Different data-id="element-415" />
        <Testimonials data-id="element-416" />
        <FAQ data-id="element-417" />
        <Offer data-id="element-418" />
        <FinalCTA data-id="element-419" />
      </main>
      <Footer data-id="element-420" />
    </div>;
}